export default "__VITE_PUBLIC_ASSET__378169e8__"